import { GelWeightBase } from './base/gel-weight-base';

export class GelWeight extends GelWeightBase { }